const removelineSpace = /[\/\\\t\n\r]/g;

// /(^[^\w\s]+)|([^\w\s]+$)|(\n|\t)|^\s+|\s+$|[^\w\s]/g; remove special character line space
export { removelineSpace };
